import { inject, InjectionToken } from '@angular/core';
import { CompanySearch } from './company-search';
import { LegacyCompanySearchService } from './legacy-company-search.service';

export const COMPANY_SEARCH = new InjectionToken<CompanySearch>(
  'COMPANY_SEARCH',
  {
    providedIn: 'root',
    factory: () => inject(LegacyCompanySearchService)
  }
);
